import { render } from "./member-profile.vue?vue&type=template&id=946946dc&scoped=true&ts=true"
import script from "./member-profile.vue?vue&type=script&lang=ts"
export * from "./member-profile.vue?vue&type=script&lang=ts"

import "./member-profile.vue?vue&type=style&index=0&id=946946dc&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/3Mswgxxg/0/im/im-web/iguopin-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-946946dc"]])

export default __exports__